import React from "react";

function Unauthorized() {
  return <div>No tienes autorización para ver esta página</div>;
}

export default Unauthorized;
